export default __webpack_public_path__ + "static/media/016-theater.442a58cf.svg";